import { render } from "./UpdateSalary.vue?vue&type=template&id=7b3e2002"
import script from "./UpdateSalary.vue?vue&type=script&lang=js"
export * from "./UpdateSalary.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__